<template>
<div>
	<div class="title">投保信息</div>
	<Form :model="form" :label-width="125" class="mt15" ref="form">
	    <FormItem label="参保公司：">
			{{form.companyName}}
		</FormItem>
	</Form>
</div>
</template>
<script>
export default {
	props:{
		info: Object,
	},
	data () {
		return {
			form: {}
		}
	},
	methods:{
		// 草稿箱
		drafts(){
			return new Promise ((resolve,rejct)=>{
				resolve(this.form)
			})
		},
		// 校验
		val () {
			return new Promise ((resolve,rejct)=>{
				this.$refs.form.validate(valid=>{
					resolve(valid?this.form:false)
				})
			})
		},
		// 回传给父组件
		change() {
			this.$emit('on-change',this.form)
		}
	},
	watch:{
		info (v) {
			this.form = v;
			console.log(this.form,'this.form')
		}
	}
}
</script>
<style scoped lang="less">
	.upload-img-main{
		padding:10px 0;
	}
	.box{
		width: 100%;
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/common/applicant.vue